module.exports = __webpack_public_path__ + "img/icon2.14239c09.png";